// extracted by mini-css-extract-plugin
module.exports = {"layoutHeader":"ViewLayoutConfigurationHeader_layoutHeader__3Uyj5","actionsContainer":"ViewLayoutConfigurationHeader_actionsContainer__1StC5"};